import script from "./NavItems.vue?vue&type=script&setup=true&lang=js"
export * from "./NavItems.vue?vue&type=script&setup=true&lang=js"

import "./NavItems.vue?vue&type=style&index=0&id=43f219b6&scoped=true&lang=scss"

import exportComponent from "/builds/smartdevops/viccarbe/viccarbe-professional-area/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43f219b6"]])

export default __exports__